import { IconButton, Stack } from "@mui/material";
import DeleteOutlineIcon from "@mui/icons-material/DeleteOutline";
import EditIcon from "@mui/icons-material/Edit";
import {
	ColDef,
	ICellRendererParams,
	ValueGetterParams,
} from "ag-grid-community";
import { TestsBySection } from "../../../models/TestsBySection";
import { CheckboxCell, CheckboxCellContext } from "../components/CheckboxCell";

const testCheckboxCol = (field: string, headerName: string): ColDef => ({
	field,
	headerName,
	cellRenderer: CheckboxCell,
	sortable: false,
	filter: false,
	resizable: false,
	flex: 1,
	minWidth: 90,
	headerClass: "ag-center-aligned-header",
});

export const useTableData = ({ isEditMode }: { isEditMode: boolean }) => {
	const columnDefs: ColDef[] = [
		{
			field: "MillName",
			headerName: "Mill",
			flex: 1,
		},
		{
			field: "SectionName",
			headerName: "Section",
			flex: 1.3,
			valueGetter: (params: ValueGetterParams<TestsBySection>) =>
				params.data?.GradeName
					? `${params.data.SectionName} - Gr. ${params.data.GradeName}`
					: params.data?.SectionName,
		},
		testCheckboxCol("Pull2", 'Pull 2"'),
		testCheckboxCol("Pull8", 'Pull 8"'),
		testCheckboxCol("Pull505", "Pull 505"),
		testCheckboxCol("Impact", "Impact"),
		testCheckboxCol("Bend", "Bend"),
		testCheckboxCol("Hardness", "Hardness"),
		{
			field: "Comments",
			headerName: "Comments",
			flex: 4,
			minWidth: 220,
			editable: isEditMode,
			cellEditor: "agLargeTextCellEditor",
			cellEditorPopup: true,
			cellEditorParams: { maxLength: 5000, rows: 6, cols: 50 },
			sortable: false,
		},
		...(isEditMode
			? [
					{
						headerName: "",
						colId: "actions",
						pinned: "right" as const,
						sortable: false,
						filter: false,
						resizable: false,
						maxWidth: 96,
						cellRenderer: (params: ICellRendererParams<TestsBySection>) => (
							<Stack direction="row" spacing={0.5}>
								<IconButton
									size="small"
									color="primary"
									title="Edit row"
									onClick={() => {
										const ctx = params.context as CheckboxCellContext;
										if (params.data) ctx.onEdit?.(params.data);
									}}
								>
									<EditIcon fontSize="small" />
								</IconButton>
								<IconButton
									size="small"
									color="error"
									title="Delete row"
									onClick={() => {
										const ctx = params.context as CheckboxCellContext;
										if (params.data) ctx.onDelete?.(params.data);
									}}
								>
									<DeleteOutlineIcon fontSize="small" />
								</IconButton>
							</Stack>
						),
					},
				]
			: []),
	];

	return { columnDefs };
};
